module.exports = __webpack_public_path__ + "media/images/diy/person_icon-66edc7f259a6c8e47a418e88092d4eca.svg";